import axiosLib from 'axios';

export const publicUrl = process.env.PUBLIC_URL;

let apiRoot;
if (process.env.NODE_ENV === 'development') {
    apiRoot = 'http://localhost:9099';
} else {
    apiRoot = document.getElementById('root').getAttribute('data-apiroot') || 'http://localhost:9000';
    if (apiRoot.indexOf('#{origin}') !== -1) {
        apiRoot = apiRoot.replace('#{origin}', window.location.origin);
    }
}

const axios = axiosLib.create({
    baseURL: apiRoot,
    withCredentials: true,
});


export {axios, apiRoot};



// WEBPACK FOOTER //
// ./src/Api.js